import React from 'react'
import { Dialog } from 'primereact/dialog'
import ProductService from '../../app/service/productService'
import DialogFooter from '../dialogFooter'
import ConstantsUtil from '../../context/constantsUtil'
import * as popUp from '../toastr'
import GeneralServices from '../../app/service/generalServices'
import DadosNfseComponent from './dadosNfseComponent'
import CustomCalendar from '../calendar/customCalendar'
import InputChooseFornecedor from '../contasAPagar/inputChooseFornecedor'
import InputChooseGrupoDePagamento from '../contasAPagar/inputChooseGrupoDePagamento'
import NfseService from '../../app/service/nfse/NfseService'
import HandleErrorService from '../../app/service/handleErrorService'
import AuthService from '../../app/service/authService'
import SelectMenu from '../selectMenu'
import { InputTextarea } from 'primereact/inputtextarea'
import { SplitButton } from 'primereact/splitbutton'
import CheckNfseDialog from './checkNfseDialog'
import FornecedorService from '../../app/service/contasAPagar/fornecedorService'
import ImportacaoNfsePDFDialog from './importacaoNfsePDFDialog'

const emptyNFSeObj = {
    dhEmi: '',
    dataCompetencia: '',
    numero: '',
    valorBruto: null,
    impostoRetidoValorPIS: 0,
    impostoRetidoValorCOFINS: 0,
    impostoRetidoValorINSS: 0,
    impostoRetidoValorIR: 0,
    impostoRetidoValorCSLL: 0,
    impostoRetidoValorISS: 0,
    valorLiquido: 0,
}
class CadastrarNfseButtonComponent extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        // this.progressService = new ProgressService();
        // this.transactionService = new TransactionService();
        this.NfseService = new NfseService()
        this.fornecedorService = new FornecedorService()
        // this.configuracaoEmpresaService = new ConfiguracaoEmpresaService();
        this.cadastrarNFSeButtonRef = React.createRef();
        this.checkNfseDialogRef = React.createRef();
    
    }

    state = {

        createNFSeDialogVisible: false,

        NFToCreate: JSON.parse(JSON.stringify(emptyNFSeObj)),

        forceUpdateQuantidadeParcelasComponent: false,

        importacaoNfsePDFDialogVisible: false,

        arquivoBase64: '',

    }

    openCreateNFSeDialog = () => {
        this.setState({createNFSeDialogVisible: true})
    }

    getCadastrarNFSeOptions = () => {
        return [
            {
                label: 'Manual',
                icon: 'pi pi-pencil',
                command: this.openCreateNFSeDialog
            },
            {
                label: 'Importar PDF',
                icon: 'pi pi-file-pdf',
                command: this.openImportacaoPDFDialog
            },
        ]
    }

    clickCriarNFSe = () => {
        this.cadastrarNFSeButtonRef.current.show()
    }

    hideCreateNFSeDialog = () => {
        this.setState({
            createNFSeDialogVisible: false,
            NFToCreate: JSON.parse(JSON.stringify(emptyNFSeObj)),
            arquivoBase64: ''
        })
    }

    handleSelectionFornecedorChange = fornecedor => {
        // console.log("fornecedor: ", fornecedor)
        let NFToCreate = this.state.NFToCreate
        NFToCreate.prestadorServico = fornecedor
        this.setState({NFToCreate})

        this.buscaFormaDePagamento(fornecedor)
        this.buscaGrupoDePagamento(fornecedor)

    }

    buscaFormaDePagamento = (fornecedor) => {
        this.fornecedorService.buscaFormaDePagamentoSalva(fornecedor.id)
        .then(response => {
            if(response.data){
                let NFToCreate = this.state.NFToCreate
                NFToCreate.formaDePagamentoFromCreateNFSe = response.data
                this.setState({
                    NFToCreate,
                    forceUpdateQuantidadeParcelasComponent: true,
                })
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }    

    buscaGrupoDePagamento = (fornecedor) => {
        this.fornecedorService.buscaGrupoDePagamento(fornecedor.id)
        .then(response => {
            let grupoDePagamento = response.data
            this.checkNfseDialogRef.current.setGrupoDePagamentoLabel(grupoDePagamento.nome)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }    

    doneForcedUpdateQuantidadeParcelasComponent = () => {
        this.setState({forceUpdateQuantidadeParcelasComponent: false})
    }

    handleImpostoRetidoChange = async (event) => {
        
        // console.log("event: ", event)

        let NFToCreate = this.state.NFToCreate
        NFToCreate = GeneralServices.alteraImpostosRetidosNfse(event, NFToCreate)
        // console.log("NFToCreate: ", NFToCreate)
        this.setState({NFToCreate})

    }

    createNFSe = () => {
        
        AuthService.startBlockUi()

        // console.log("this.state.NFToCreate inicial: ", this.state.NFToCreate)
        
        let NFToCreate = GeneralServices.parseNfseImpostosRetidos(this.state.NFToCreate)
        
        if(this.state.arquivoBase64){
            NFToCreate.possuiPdf = true
            NFToCreate.arquivoBase64 = this.state.arquivoBase64
        }
        
        // console.log("NFToCreate final: ", NFToCreate)

        this.NfseService.createNFSeManual(NFToCreate)
        .then(response => {
            popUp.successPopUp("Nota Fiscal de Serviço cadastrada com sucesso!")
            setTimeout(() => window.location.reload(), 500)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
        
    }




    openImportacaoPDFDialog = () => {
        this.setState({importacaoNfsePDFDialogVisible: true})
    }

    hideImportacaoNfsePDFDialog = (isFinishUpload) => {
        this.setState({importacaoNfsePDFDialogVisible: false})
        
        if(!isFinishUpload){
            this.setState({arquivoBase64: ''})
        }
    }

    getUploadFiles = (files) => {
        
        if (!files || files.length < 1) return;

        let file = files[0]

        //Define a função onload que será usada dentro de readAsDataURL em GeneralServices.transformaAquivoEmBase64.
        let onloadFunction = (reader) => {
            
            const arquivoBase64 = reader.result.split(',')[1]; 
            // console.log('Base64 do arquivo:', arquivoBase64);
            
            this.setState({arquivoBase64})

        };

        GeneralServices.transformaAquivoEmBase64(file, onloadFunction)

    }

    onFinishUpload = async (nfseUploadResult) => {

        if(nfseUploadResult.mensagemInfo){
            popUp.warningPopUp(nfseUploadResult.mensagemInfo)
        }
        
        await this.setState({NFToCreate: {
            dhEmi: nfseUploadResult.dhEmi?.split(" ")[0].replaceAll("/", "-"),
            dataCompetencia: nfseUploadResult.dataCompetencia?.replaceAll("/", "-"),
            numero: nfseUploadResult.numero,
            codigoVerificacao: nfseUploadResult.codigoVerificacao,
            servico: nfseUploadResult.servico,
            prestadorServico: nfseUploadResult.prestadorServico,
            valorBruto: nfseUploadResult.valorBruto,
            valorLiquido: nfseUploadResult.valorBruto,
            impostoRetidoValorPIS: 0,
            impostoRetidoValorCOFINS: 0,
            impostoRetidoValorINSS: 0,
            impostoRetidoValorIR: 0,
            impostoRetidoValorCSLL: 0,
            impostoRetidoValorISS: 0,
        }})

        this.hideImportacaoNfsePDFDialog(true)
        this.openCreateNFSeDialog()

    }

    render(){

        const renderCreateNFSeDialog = () => {
            return (
                <CheckNfseDialog
                    ref={this.checkNfseDialogRef}
                    visible={this.state.createNFSeDialogVisible}
                    isCreateNFSe
                    register={false}
                    NFToValidate={this.state.NFToCreate}
                    save={this.createNFSe}
                    atualizaGrupoDePagamento={this.atualizaGrupoDePagamento}
                    hideDialog={this.hideCreateNFSeDialog}
                    handleSelectionFornecedorChange={this.handleSelectionFornecedorChange}
                    handleImpostoRetidoChange={this.handleImpostoRetidoChange}
                    forceUpdateQuantidadeParcelasComponent={this.state.forceUpdateQuantidadeParcelasComponent}
                    doneForcedUpdateQuantidadeParcelasComponent={this.doneForcedUpdateQuantidadeParcelasComponent}
                />
            )
        }

        const renderPDFUploadDialog = () => {
            if(this.state.importacaoNfsePDFDialogVisible)
            return(
                <ImportacaoNfsePDFDialog
                    visible={this.state.importacaoNfsePDFDialogVisible}
                    hideDialog={this.hideImportacaoNfsePDFDialog}
                    onFinishUpload={this.onFinishUpload}
                    getUploadFiles={this.getUploadFiles}
                />
            )
        }

        return (

            <>

                <SplitButton
                    ref={this.cadastrarNFSeButtonRef}
                    label="Cadastrar NFSe"
                    icon="pi pi-plus"
                    model={this.getCadastrarNFSeOptions()}
                    onClick={this.clickCriarNFSe}
                    // tooltip={ConstantsUtil.exportXlsxLabel}
                    // tooltipOptions={{position: 'top'}}
                />

                {renderCreateNFSeDialog()}

                {renderPDFUploadDialog()}

            </>

        )
    }


}

export default CadastrarNfseButtonComponent